//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: {
            type: String
        },
        rate_opts: {
            type: Array
        },
        discount_opts: {
            type: Array
        },
        default_rate: {
            type: Number
        },
        default_discount: {
            type: Number
        }
    },
    data () {
        return {
            rate: this.default_rate,
            discount: this.default_discount,
            custom_rate: ''
        }
    },
    methods: {
        changePicker ({ detail: { value: [rate, discount] }}) {
            this.rate = rate
            this.discount = discount
        },
        confirmPicker () {
            this.$emit('changePicker', this.rate, this.discount)
            this.hide()
        },
        confirmCustom () {
            const rate = Number(this.custom_rate)
            if (rate && !isNaN(rate)) {
                this.$emit('change', rate)
                this.hide()
            } else {
                wx.showToast({
                    title: '请填写正确的利率',
                    icon: 'none'
                })
            }
        },
        hide () {
            this.$emit('hide')
        }
    }
}
